import { useEffect, useState } from "react";

const links = [
  { href: "#home", label: "首页大厅" },
  { href: "#hot", label: "瓜田热榜" },
  { href: "#field", label: "正在蹲的瓜" },
  { href: "#line", label: "连瓜时间线" },
  { href: "#guide", label: "蹲帖指南" },
  { href: "#about", label: "关于瓜吧" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const jumpToField = () => {
    setOpen(false);
    document.getElementById("field")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-40 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur-md shadow-[0_1px_0_0_oklch(var(--background-200))]"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-content items-center justify-between px-4 md:px-6 h-16">
        <a href="#home" className="flex items-center gap-2.5 whitespace-nowrap" aria-label="吃瓜吧 首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-500 text-base font-bold text-background-50 shadow-[0_4px_10px_-4px_oklch(var(--accent-500)/0.7)]">
            瓜
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-xl text-foreground-950">吃瓜吧</span>
            <span className="text-[11px] tracking-widest text-foreground-500">盖楼蹲帖 · 不掉线</span>
          </span>
        </a>

        <ul className="hidden items-center gap-1 lg:flex">
          {links.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                className="rounded-full px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-200/70 hover:text-primary-600"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-2">
          <button
            onClick={jumpToField}
            className="hidden whitespace-nowrap items-center gap-1.5 rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            <i className="ri-add-line text-base leading-none" />
            去蹲一瓜
          </button>
          <button
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? "关闭菜单" : "打开菜单"}
            className="inline-flex h-10 w-10 items-center justify-center rounded-full text-xl text-foreground-800 hover:bg-background-200/70 lg:hidden"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} leading-none`} />
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50/95 backdrop-blur lg:hidden">
          <ul className="mx-auto flex max-w-content flex-col px-4 py-2">
            {links.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="block rounded-lg px-3 py-3 text-sm font-medium text-foreground-800 hover:bg-background-200/60"
                >
                  {l.label}
                </a>
              </li>
            ))}
            <li className="p-2">
              <button
                onClick={jumpToField}
                className="w-full whitespace-nowrap rounded-full bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-600"
              >
                去蹲一瓜
              </button>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}